import { FormattedMessage } from 'react-intl';
import GlassCard from '@/app/components/GlassCard';
import PublicLayout from '@/app/layouts/PublicLayout';

export default function PrivacyPage() {
  return (
    <PublicLayout>
      <GlassCard>
        <div className="space-y-8 text-slate-700">
          <header className="space-y-2">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-400">
              <FormattedMessage id="legal.privacy.kicker" />
            </p>
            <h1 className="text-3xl font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.title" />
            </h1>
            <p className="text-sm text-slate-500">
              <FormattedMessage id="legal.privacy.effectiveDate" />
            </p>
          </header>

          <p className="text-sm text-slate-600">
            <FormattedMessage id="legal.privacy.intro" />
          </p>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section1.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section1.body" />
            </p>
            <ul className="list-disc space-y-2 pl-5 text-sm text-slate-600">
              <li><FormattedMessage id="legal.privacy.section1.item1" /></li>
              <li><FormattedMessage id="legal.privacy.section1.item2" /></li>
              <li><FormattedMessage id="legal.privacy.section1.item3" /></li>
              <li><FormattedMessage id="legal.privacy.section1.item4" /></li>
              <li><FormattedMessage id="legal.privacy.section1.item5" /></li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section2.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section2.body" />
            </p>
            <ul className="list-disc space-y-2 pl-5 text-sm text-slate-600">
              <li><FormattedMessage id="legal.privacy.section2.item1" /></li>
              <li><FormattedMessage id="legal.privacy.section2.item2" /></li>
              <li><FormattedMessage id="legal.privacy.section2.item3" /></li>
              <li><FormattedMessage id="legal.privacy.section2.item4" /></li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section3.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section3.body" />
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section4.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section4.body" />
            </p>
            <ul className="list-disc space-y-2 pl-5 text-sm text-slate-600">
              <li><FormattedMessage id="legal.privacy.section4.item1" /></li>
              <li><FormattedMessage id="legal.privacy.section4.item2" /></li>
              <li><FormattedMessage id="legal.privacy.section4.item3" /></li>
              <li><FormattedMessage id="legal.privacy.section4.item4" /></li>
              <li><FormattedMessage id="legal.privacy.section4.item5" /></li>
            </ul>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section5.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section5.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section6.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section6.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section7.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section7.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section8.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section8.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section9.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section9.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section10.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section10.body" />
            </p>
          </section>

          <section className="space-y-2">
            <h2 className="text-lg font-semibold text-slate-900">
              <FormattedMessage id="legal.privacy.section11.title" />
            </h2>
            <p className="text-sm text-slate-600">
              <FormattedMessage id="legal.privacy.section11.body" />
            </p>
          </section>
        </div>
      </GlassCard>
    </PublicLayout>
  );
}
